import { CookieStorage } from "@front/services/storage";
import { setListener } from "@front/utils";
import { createComponent } from "@front/utils/alpine";

export default createComponent(({$persist}) => ({
    addToCartButton: undefined as HTMLButtonElement | undefined,
    hasError: false,

    customization: $persist({
        size: '',
        redirectTo: '',
    }).using(CookieStorage),

    onChange (value) {
        // @fractodoc - réintégration de :
        // themes/lepage-v1/_dev/js/product.js#L415
        this.customization.size = value;

        var formData = new FormData( this.$refs.form );
        const alpine = this;
        const xhr = new XMLHttpRequest();
        xhr.open(this.$refs.form.method, this.$refs.form.action);
        xhr.onload = function() {
            alpine.toggleCartButton();
        };
        xhr.send(formData);

    },

    init () {
        this.addToCartButton = document.querySelector<HTMLButtonElement>('[data-button-action="add-to-cart"]');

        // @fractodoc - réintégré mais utilité ?
        // themes/lepage-v1/_dev/js/product.js#L167
        if (this.customization.size.length > 0 && this.customization.redirectTo == window.location.href) {
            this.$refs.sizeInput.value = this.customization.size;
            this.customization.size = '';
        }

        this.toggleCartButton();
    },


    toggleCartButton() {
        if (this.addToCartButton)
            if(this.$refs.sizeInput.value == '')
                this.addToCartButton.disabled = true;
            else
                this.addToCartButton.disabled = false;

        if(this.$refs.overlay) {

            if(this.$refs.sizeInput.value == '') {
                this.$refs.overlay.classList.remove('hidden');
            } else {
                if(! this.$refs.overlay.classList.contains('hidden'))
                    this.$refs.overlay.classList.add('hidden');
                this.hasError = false;
            }

            this.$refs.overlay.addEventListener('click', () => {
                this.hasError = this.$refs.sizeInput.value == '';
            });
        }
    },

}));
